import { useAccessibility } from "../../../context/AccessibilityContext/AccessibilityContext";
import Block from "../../../components/Block/Block";
import FadeIn from "../../../components/FadeIn/FadeIn";
import Link from "../../../components/Link/Link";
import style from './internationalblock.module.scss';

const InternationalBlock = () => {
    const { settings } = useAccessibility();

    // Accessibility-aware colors
    const backgroundColor = settings.contrast === 'default' ? 'rgba(255, 255, 255, 0.85)' : 'var(--bg-primary)';
    const textColor = settings.contrast === 'default' ? '#231f20' : 'var(--text-primary)';
    const linkColor = settings.contrast === 'default' ? '#1d3e8c' : 'var(--accent-color)';

    return (
        <Block
            flexDirection='column'
            justifyContent='start'
            alignItems='start'
            width="75%"
            height='fit-content'
            background={backgroundColor}
            header='МЕЖДУНАРОДНОЕ СОТРУДНИЧЕСТВО'
            headerColor={textColor}
            id='international'
            aria-label="Международное сотрудничество"
            role="region"
        >
            <FadeIn>
                <div className={style.content}>
                    <div className={style.wrapperData}>
                        {/* Международное сотрудничество */}
                        <section aria-labelledby="international-cooperation">
                            <h4 id="international-cooperation" className={style.header} style={{ color: textColor }}>
                                Международное сотрудничество
                            </h4>
                            <div className={style.text} style={{ color: textColor }}>
                                <p>В ГБУ ДО КК СШОР "Самбо" международное сотрудничество не предусмотрено.</p>
                                <p>Отсутствуют заключенные и планируемые к заключению договоры с иностранными и международными организациями по вопросам образования и науки.</p>
                            </div>
                        </section>
                    </div>
                </div>
            </FadeIn>
        </Block>
    )
}

export default InternationalBlock;